import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { IFillDataWizardBuy } from "../../..";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import Button from "../../../../../../../ui/button";
import useDealRequest, {
  EDealRequestType,
} from "../../../../../../../../api/hooks/use-deal-request";
import { getAccessToken } from "../../../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AuthModal from "../../../../../../auth/components/modals/authModal";
import { EMarketTypes } from "../../../../../../../../interfaces";
import { PATHS } from "../../../../../../../shared/constants";
import useOpenModal from "../../../../../../../ui/modal/hooks/useOpenModal";

interface ISureBuyStepBuy_5 {
  data: IFillDataWizardBuy;
}

const SureBuyStepBuy_5 = ({ data }: ISureBuyStepBuy_5) => {
  const { goToStep } = useWizard();
  const navigate = useNavigate();

  const {
    data: dataDealRequest,
    error,
    isMutating,
    trigger,
  } = useDealRequest();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.buy.step_4);
  };

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({
          type: EDealRequestType.Purchase,
          data,
          marketType: EMarketTypes.SECONDARY,
        });
        toast.success("Заявка на покупку создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={openAuth}
            onClose={() => handleChangeModalAuth(false)}
            offsetY={offsetYAuth}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default SureBuyStepBuy_5;
